<template>
  <div class="page">
    <div class="header">
      <img src="../../assets/images/activity/live-broadcast-icon3.png">
    </div>
    <div class="content">
      <div class="input-row" :class="{ 'active-border': active === 'workshopName' }">
        <div class="icon-input icon-user" :class="{ active: (active === 'workshopName' || registerData.workshopName) }">
          <img src="../../assets/images/activity/live-broadcast-icon4.png">
          <span>修理厂</span>
        </div>
        <van-field v-model="registerData.workshopName" center clearable :placeholder="placeholder.workshopName" @focus="handleFocus($event, '请输入修理厂名称', 'workshopName')" @blur="handleBulr('workshopName')"/>
      </div>
      <div class="input-row" :class="{ 'active-border': active === 'contactPerson' }">
        <div class="icon-input icon-user" :class="{ active: (active === 'contactPerson' || registerData.contactPerson) }">
          <img src="../../assets/images/activity/live-broadcast-icon5.png">
          <span>联系人</span>
        </div>
        <van-field v-model="registerData.contactPerson" center clearable :placeholder="placeholder.contactPerson" @focus="handleFocus($event, '请输入联系人', 'contactPerson')" @blur="handleBulr('contactPerson')"/>
      </div>
      <div class="input-row" :class="{ 'active-border': active === 'contactPhone' }">
        <div class="icon-input icon-user" :class="{ active: (active === 'contactPhone' || registerData.contactPhone) }">
          <img src="../../assets/images/activity/live-broadcast-icon6.png">
          <span>电话</span>
        </div>
        <van-field v-model="registerData.contactPhone" center clearable :placeholder="placeholder.contactPhone" @focus="handleFocus($event, '请输入电话', 'contactPhone')" @blur="handleBulr('contactPhone')"/>
      </div>
      <div class="input-row" :class="{ 'active-border': active === 'provinceName' }">
        <div class="icon-input icon-user" :class="{ active: (active === 'provinceName' || registerData.provinceName) }">
          <img src="../../assets/images/activity/live-broadcast-icon7.png">
          <span>省份</span>
        </div>
        <van-field v-model="registerData.provinceName" center clearable :placeholder="placeholder.provinceName" @focus="handleFocus($event, '请输入省份', 'provinceName')" @blur="handleBulr('provinceName')"/>
      </div>
      <div class="input-row" :class="{ 'active-border': active === 'cityName' }">
        <div class="icon-input icon-user" :class="{ active: (active === 'cityName' || registerData.cityName) }">
          <img src="../../assets/images/activity/live-broadcast-icon10.png">
          <span>城市</span>
        </div>
        <van-field v-model="registerData.cityName" center clearable :placeholder="placeholder.cityName" @focus="handleFocus($event, '请输入城市', 'cityName')" @blur="handleBulr('cityName')"/>
      </div>
      <div class="input-row input-row-title">
        <div class="icon-input icon-user">
          <img src="../../assets/images/activity/live-broadcast-icon8.png">
          <span>详细地址（选填）</span>
        </div>
      </div>
      <div class="textarea-row" :class="{ 'active-border-all': active === 'workshopAddress' }">
        <van-field type="textarea" v-model="registerData.workshopAddress" center clearable @focus="handleFocus($event, '详细地址', 'workshopAddress')" @blur="handleBulr('workshopAddress')"/>
      </div>

      <div class="info">请确认信息无误后提交，后续会有经销商或客服联系您核实信息完善注册。</div>
      <div class="button-line" @click="submit">提交</div>
      <div class="operate text-right">
        <span @click="goLogin">已有帐号 登录</span>
      </div>
    </div>

    <!-- <div class="activity-img">
      <img class="activity-img-icon1" src="../../assets/images/activity/live-broadcast-icon1.png">
      <div>
        <img class="activity-img-icon2" src="../../assets/images/activity/live-broadcast-icon2.png">
      </div>
    </div> -->

    <LiveBroadcastPop ref="liveBroadcastPop">
      <div slot="title">
        提交成功
        <div style="color: #999; font-weight: 500; font-size: 16px">注意保持电话畅通</div>
      </div>
      <div slot="content" class="pop-content-integral">
        <div>注册成功即可获得1000易加积分奖励!</div>
      </div>
    </LiveBroadcastPop>
  </div>
</template>

<script>
import LiveBroadcastPop from './components/live-broadcast-pop'
import activityApi from '@/api/activity'
// import { commonUtils } from '@/utils/common'
export default {
  name: 'LiveBroadcastRegister',
  components: {
    LiveBroadcastPop
  },
  data () {
    return {
      registerData: {
        workshopName: '',
        contactPerson: '',
        contactPhone: '',
        provinceName: '',
        cityName: '',
        workshopAddress: ''
      },
      placeholder: {
        workshopName: null,
        contactPerson: null,
        contactPhone: null,
        provinceName: null,
        cityName: null,
        workshopAddress: null
      },
      active: null
    }
  },
  methods: {
    submit () {
      let isValidData = true
      for (let key in this.registerData) {
        if (!this.registerData[key] && key !== 'workshopAddress') {
          this.$dialog.alert({ message: '请正确填写所有信息' })
          isValidData = false
        }
      }
      if (!isValidData) {
        return
      }
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        mask: true,
        message: '加载中...'
      })
      let params = Object.assign({}, this.registerData, { streamingCode: this.$route.query.activityCode })
      activityApi.registerAccount(params).then(response => {
        this.$toast.clear()
        if (response.data.resultCode === '0') {
          this.$refs['liveBroadcastPop'].popShow = true
        }
      }).catch(() => {
        this.$toast.clear()
      })
    },
    goLogin () {
      // this.$router.push('/activity/live-broadcast-login')
      this.$router.push({ path: '/activity/streaming-verification', query: { activityCode: this.$route.query.activityCode || '' } })
    },
    handleFocus (event, text, target) {
      this.placeholder[target] = text
      this.active = target
    },
    handleBulr (target) {
      this.placeholder[target] = null
      this.active = null
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  min-height: calc(100vh);
  padding-top: 0;
  padding-bottom: 30px;
  background: #fff;
}
.header {
  position: relative;
  padding-bottom: 10px;
  img {
    width: 100%;
  }
  .header-logo {
    position: absolute;
    top: 0;
    left: 10px;
    width: 30px;
  }
}
.activity-img {
  width: 100%;
  height: 160px;
  padding-top: 50px;
  text-align: center;
  .activity-img-icon1 {
    width: 80%;
  }
  .activity-img-icon2 {
    width: 50px;
  }
}
.subject {
  display: flex;
  justify-content: space-around;
  text-align: center;
  font-size: 22px;
  width: 30%;
  // line-height: 34px;
  font-weight: 700;
  color: rgb(52, 122, 127);
  margin: 0 auto;
  margin-bottom: 30px;
  padding-bottom: 5px;
  background: url('../../assets/images/activity/form-verification-desc.png') bottom no-repeat;
  background-size: 95% auto;
}
.content {
  width: 80%;
  margin: 0 auto;
}
.input-row {
  position: relative;
  height: 40px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 20px;
  transition: all .5s ease;
  .icon-input {
    position: absolute;
    z-index: 10;
    top: 10px;
  }
  .icon-user {
    left: 10px;
    img {
      height: 20px;
    }
  }
  .icon-pwd {
    left: 10px;
    width: 13px;
    height: 15px;
    img {
      width: 13px;
      height: 15px;
    }
  }
  .icon-right {
    top: 14px;
    right: 10px;
    .pwd-hide {
      width: 18px;
      height: 8px;
    }
    .pwd-show {
      width: 16px;
      height: 10px;
    }
  }
  .van-cell {
    height: 40px;
    padding-left: 36px;
    border-radius: 20px;
  }
  .pwd-cell {
    padding-right: 36px;
  }
  ::-webkit-input-placeholder{
    color: #ccc;
  }
  span {
    padding-left: 8px;
    line-height: 0;
    vertical-align: super;
    font-size: 14px;
    color: #ccc;
  }
  .active {
    transition: all .2s ease;
    top: -10px;
    left: 0;
    span {
      font-weight: 600;
    }
  }
}
.active-border {
  border-bottom: 1px solid #2196f3;
}
.input-row-title {
  text-align: center;
  margin-bottom: 0px;
  border: 0px;
}
.textarea-row {
  border-radius: 3px;
  border: 0.02667rem solid #ddd;
}
.active-border-all {
  border: 1px solid #2196f3;
}
.info {
  padding: 10px 0 20px 0;
  color: rgb(166, 166, 166);
}
.button-line {
  height: 40px;
  line-height: 40px;
  border-radius: 20px;
  margin: 20px 0 15px;
  background-image: linear-gradient(to right, rgba(52, 122, 127, .8), rgba(52, 122, 127, 1));
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
}
.operate {
  width: 30%;
  margin: 0 auto;
  padding: 10px 0 5px 0;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  color: rgb(52, 122, 127);
  border-bottom: 1px solid rgb(52, 122, 127);;
}
.tips {
  padding: 22px 0;
  line-height: 24px;
  text-align: center;
  font-size: 14px;
  color: rgb(52, 122, 127);
}

.van-popup {
  width: 270px;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0);
  .pop-content {
    background: url("../../assets/images/activity/form-verification-header2.png") top no-repeat;
    background-size: 100% auto;
    padding: 30px 5px;
    text-align: center;
    border-radius: 10px;
    background-color: #fff;
    .pop-content-img {
      position: relative;
      width: 200px;
      padding-top: 20px;
      margin: 20px auto;
      img {
        width: 100%;
        height: 100%;
      }
      .pop-content-right {
        position: absolute;
        right: 0;
        bottom: 8px;
        width: 30px;
        height: 30px;
      }
    }
    .pop-content-title {
      // font-weight: bold;
      line-height: 20px;
      font-size: 18px;
    }
    .pop-content-integral {
      line-height: 30px;
      font-size: 14px;
      color: #999;
    }
    .pop-content-btn {
      padding-top: 20px;
      .button-line {
        height: 35px;
        line-height: 35px;
        margin: 0 50px;
        font-weight: 400;
        background-color: rgba(52, 122, 127, 1);
      }
    }
  }
  .pop-close {
    width: 39px;
    height: 39px;
    margin: 32px auto 0 auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
